import React from 'react';
import { Anchor } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function UniqueMechanism() {
  return <section className="bg-periwinkle py-24 px-6 md:px-12 text-cream" data-id="element-128">
      <div className="max-w-4xl mx-auto text-center" data-id="element-129">
        <FadeIn data-id="element-130">
          <div className="flex justify-center mb-8" data-id="element-131">
            <div className="bg-cream/20 p-4 rounded-full" data-id="element-132">
              <Anchor className="w-10 h-10 text-cream" data-id="element-133" />
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl mb-10" data-id="element-134">
            El Método del Ancla Invisible
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-135">
          <p className="text-xl md:text-2xl leading-relaxed font-light mb-8" data-id="element-136">
            A diferencia de los entrenamientos tradicionales, este sistema se
            basa en la{' '}
            <strong className="font-semibold" data-id="element-137">sintonía biológica</strong>.
          </p>
          <div className="bg-brown/10 p-8 md:p-12 rounded-3xl backdrop-blur-sm border border-cream/20" data-id="element-138">
            <p className="text-lg md:text-xl leading-relaxed" data-id="element-139">
              En lugar de desaparecer y generar angustia, usamos una técnica de{' '}
              <strong data-id="element-140">"Presencia Gradual"</strong> que engaña al sistema
              nervioso del bebé: él siente que seguís ahí a través de
              micro-ajustes táctiles y sonoros, permitiendo que su cerebro pase
              a sueño profundo por sí mismo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}